// extracted by mini-css-extract-plugin
export default {"zoomControls":"dwa-z","zoomControlButton":"ewa-z","zoomBanner":"fwa-z","bannerButton":"gwa-z","imageButton":"hwa-z","zoom":"iwa-z","zoomContent":"jwa-z"};